import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export default class VisitorsProfilesRoute extends Route {
  @service declare router: RouterService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare abilities: AbilitiesService;

  beforeModel(): void {
    if (!this.featureFlags.isEnabled('visitor-profiles-m1')) {
      void this.router.transitionTo('unauthorized');
    }

    if (!this.abilities.can('read visitor-profile')) {
      void this.router.transitionTo('unauthorized');
    }
  }
}
